/* eslint-disable no-underscore-dangle,@typescript-eslint/no-unused-vars */

import { DESIGNER_EVENTS } from '../../../app/constants/designer_events';

xplenty.directive('packageNameEditor', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('../../../views/directives/package-name-editor.html'),

      replace: true,

      scope: {
        item: '=ngModel',
      },

      link(scope, element, attrs) {},
      controller: [
        '$scope',
        '$rootScope',
        '$q',
        'modalService',

        function ($scope, $rootScope, $q, modalService) {
          $scope.nameChanged = false;

          $scope._default = angular.copy($scope.item);

          const isValid = function () {
            return $scope.packageForm.$valid;
          };

          $scope.$watch(
            'item',
            function (_package) {
              $scope.nameChanged =
                (_package.name !== $scope._default.name || _package.description !== $scope._default.description) &&
                isValid();
            },
            true,
          );

          $scope.save = function () {
            const defer = $q.defer();
            if (isValid()) {
              $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_NAME_SAVE, $scope.item);
              modalService.hideModal();
              defer.resolve();
            } else {
              defer.reject();
            }
            return { $promise: defer.promise };
          };
        },
      ],
    };
  },
]);
